import React from 'react';
import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../BlockContent.utils';

interface IframeSerializerProps {
  value: { src: string; height?: number | string; width?: number | string };
}

const IframeBlock = ({ value: { src, height, width } }: IframeSerializerProps) => (
  <iframe
    title={`iframe: ${src}`}
    src={src}
    height={height}
    width={width || '100%'}
    style={{ border: 'none' }}
    allow="fullscreen"
  />
);

export const IframeSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: IframeSerializerProps) => (
      <StyledArticleBlockContentGridCol>
        <IframeBlock value={value} />
      </StyledArticleBlockContentGridCol>
    );
  }
  return ({ value }: IframeSerializerProps) => <IframeBlock value={value} />;
};

const StyledArticleBlockContentGridCol = styled(ArticleBlockContentGridCol)`
  margin: ${spacing.space32} 0;
  @media (max-width: ${breakpoints.m}) {
    margin: ${spacing.space24} 0;
  }
`;
